import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEvent,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Responses } from 'src/app/models/interfaces/responses';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiEntryControlService {
  public domain: string = environment.baseApiUrl;
  constructor(private http: HttpClient) { }

  isLogged(): Observable<any> {
    return this.http.get<Responses>(this.domain + 'admin/user/auth/');
  }

  // El backend devuelve la ruta del reporte generado relativa al dominio de la API,
  // que es distinto al del front, así que hay que anteponerle el dominio de la API
  // para poder abrirla.
  private fixReportPath(response: any): any {
    if (response?.path && !/^https?:\/\//i.test(response.path)) {
      response.path = environment.baseWebsiteUrl + response.path;
    }
    return response;
  }

  generateReport(form: UntypedFormGroup, type: number = 1): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value)
    return this.http.get<Responses>(
      this.domain + 'admin/records/reports/' + type,
      { params: params }
    ).pipe(map((response: any) => this.fixReportPath(response)));
  }
  getUser(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/users/' + id
    );
  }
  getGuard(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/guards/' + id
    );
  }
  getContentStore(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/stores/info_panel/' + id
    );
  }
  getStore(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/stores/' + id
    );
  }
  getFacility(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/facility/' + id
    );
  }
  getMyStore(): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/stores/my'
    );
  }
  getDevice(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/devices/' + id
    );
  }
  getTag(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/tags/' + id
    );
  }

  getRoundConfiguration(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/rounds/' + id
    );
  }

  getEmployee(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/employees/' + id
    );
  }
  getProvider(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/providers/' + id
    );
  }
  getVisitor(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/visitors/' + id
    );
  }
  getDriver(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/drivers/' + id
    );
  }
  getCar(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/cars/' + id
    );
  }
  getAllStores(): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/stores/'
    );
  }
  getAllStoresByFacility(facility_id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/stores/allFacility/' + facility_id
    );
  }
  getAllFeaturesFilter(filter: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/features/filter/' + filter
    );
  }
  getAllDriverStore(storeId: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/drivers/all/' + storeId
    );
  }
  getAllDriverAvailablesStore(storeId: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/drivers/availables/' + storeId
    );
  }
  getAllDriverCar(carsId: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/drivers/all/' + carsId
    );
  }

  getAllTagsFacility(facility_id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/tags/all/' + facility_id
    );
  }
  getAllFacility(): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/facility/'
    );
  }
  getAllRoundsType(): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/rounds/types/'
    );
  }

  paginateStore(page: number, form: UntypedFormGroup): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value)
    return this.http.get<Responses>(
      this.domain + 'admin/stores/paginate/' + page +
      '/30/',
      { params: params }
    );
  }
  paginateFacility(page: number, form: UntypedFormGroup): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value)
    return this.http.get<Responses>(
      this.domain + 'admin/facility/paginate/' + page +
      '/30/',
      { params }
    );
  }
  paginateFacilityExclusive(page: number): Observable<Responses> {

    return this.http.get<Responses>(
      this.domain + 'admin/facility/paginatex/' + page +
      '/30/'
    );
  }
  paginateDevices(page: number, form: UntypedFormGroup): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value)
    return this.http.get<Responses>(
      this.domain + 'admin/devices/paginate/' + page +
      '/30/',
      { params: params }
    );
  }
  /** Teléfonos desde los que han iniciado sesión supervisores (para vincularlos a un perfil). */
  supervisorKnownPhones(): Observable<Responses> {
    return this.http.get<Responses>(this.domain + 'admin/devices/supervisor_known');
  }
  /** Perfiles de supervisor vigentes. */
  supervisorProfiles(): Observable<Responses> {
    return this.http.get<Responses>(this.domain + 'admin/supervision_profiles');
  }
  /** Vincula un teléfono a un perfil de supervisor (un perfil puede tener varios teléfonos). */
  assignSupervisorPhone(deviceId: string, profileId: number, deviceName: string): Observable<Responses> {
    const body = new HttpParams().set('device_id', deviceId).set('profile_id', profileId).set('device_name', deviceName);
    return this.http.post<Responses>(this.domain + 'admin/devices/assign_supervisor', body, {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
    });
  }
  /** Retira un teléfono de supervisor de su perfil (soft delete). */
  unassignSupervisorPhone(id: number): Observable<Responses> {
    return this.http.post<Responses>(this.domain + 'admin/devices/unassign_supervisor/' + id, new HttpParams());
  }
  paginateTags(page: number, form: UntypedFormGroup): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value)
    return this.http.get<Responses>(
      this.domain + 'admin/tags/paginate/' + page +
      '/30/',
      { params: params }
    );
  }
  paginateUsers(page: number, storeId: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/users/paginate/' + page +
      '/30/' + storeId
    );
  }
  /**
   * Altas o bajas masivas de guardias desde un archivo del sistema de RRHH (CSV o Excel). El servidor reconoce el tipo de
   * archivo por su contenido. Sin `apply` solo revisa y devuelve lo que haría.
   */
  importGuardsRrhh(kind: 'terminations' | 'workers', file: File, apply: boolean): Observable<Responses> {
    const body = new FormData();
    body.append('file', file);
    body.append('apply', apply ? '1' : '0');
    return this.http.post<Responses>(this.domain + 'admin/guards/import_' + kind, body);
  }

  // ------------------------------------------------------------- cargos del personal

  getGuardPositions(): Observable<Responses> {
    return this.http.get<Responses>(this.domain + 'admin/guard_positions/index');
  }

  saveGuardPosition(data: { id?: number | null; name: string; color?: string }): Observable<Responses> {
    let body = new HttpParams().set('name', data.name).set('color', data.color ?? '');
    if (data.id) body = body.set('id', String(data.id));
    return this.http.post<Responses>(this.domain + 'admin/guard_positions/save', body);
  }

  deleteGuardPosition(id: number): Observable<Responses> {
    return this.http.post<Responses>(this.domain + `admin/guard_positions/delete/${id}`, new HttpParams());
  }

  paginateGuards(page: number, form: UntypedFormGroup): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value);
    return this.http.get<Responses>(
      this.domain + 'admin/guards/paginate/' + page +
      '/30/',
      { params: params }
    );
  }
  paginateEmployees(page: number, form: UntypedFormGroup, storeId: number): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value);
    return this.http.get<Responses>(
      this.domain + 'admin/employees/paginate/' + page +
      '/30/' + storeId,
      { params: params }
    );
  }
  paginateProviders(page: number, form: UntypedFormGroup, storeId: number): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value);
    return this.http.get<Responses>(
      this.domain + 'admin/providers/paginate/' + page +
      '/30/' + storeId,
      { params: params }
    );
  }
  paginateVisitors(page: number, form: UntypedFormGroup, storeId: number): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value);
    return this.http.get<Responses>(
      this.domain + 'admin/visitors/paginate/' + page +
      '/30/' + storeId,
      { params: params }
    );
  }
  paginateDrivers(page: number, storeId: number): Observable<Responses> {

    return this.http.get<Responses>(
      this.domain + 'admin/drivers/paginate/' + page +
      '/30/' + storeId
    );
  }
  paginateCars(page: number, storeId: number, form?: UntypedFormGroup): Observable<Responses> {
    let params = form ? new HttpParams().appendAll(form.value) : new HttpParams();
    return this.http.get<Responses>(
      this.domain + 'admin/cars/paginate/' + page +
      '/30/' + storeId,
      { params: params }
    );
  }
  paginateRecords(page: number, form: UntypedFormGroup, type: number = 1): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value);
    return this.http.get<Responses>(
      this.domain + 'admin/records/paginate/' + page +
      '/30/' + type,
      { params: params }
    );
  }
  paginateMyRecords(page: number, start: string, end: string): Observable<Responses> {
    let params = new HttpParams()
      .set('start', start)
      .set('end', end);
    return this.http.get<Responses>(
      this.domain + 'admin/records/mypaginate/' + page +
      '/30/',
      { params: params }
    );
  }
  paginateMyRounds(page: number, form: UntypedFormGroup): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value)
    return this.http.get<Responses>(
      this.domain + 'admin/records/myrounds/' + page +
      '/30/',
      { params: params }
    );
  }
  paginateRecordsFacility(page: number, form: UntypedFormGroup, type: number): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value)
    return this.http.get<Responses>(
      this.domain + 'admin/records/paginate/' + page +
      '/30/' + type,
      { params: params }
    );
  }
  paginateRoundsConfiguration(page: number, form: UntypedFormGroup): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value)
    return this.http.get<Responses>(
      this.domain + 'admin/rounds/paginate/' + page +
      '/30/',
      { params: params }
    );
  }
  paginateStoresFacility(page: number, form: UntypedFormGroup): Observable<Responses> {
    let params = new HttpParams().appendAll(form.value);
    return this.http.get<Responses>(
      this.domain + 'admin/stores/paginate/' + page +
      '/30/',
      { params: params }
    );
  }
  createUsers(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/users/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createGuards(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/guards/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createStore(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/stores/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createDevices(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/devices/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createTags(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/tags/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createEmployees(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/employees/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createProviders(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/providers/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createVisitors(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/visitors/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createDrivers(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/drivers/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createCars(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/cars/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createFacility(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/facility/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createRoundsConfiguration(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/rounds/create/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }

  updateRoundsConfiguration(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/rounds/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateUsers(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/users/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateGuards(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/guards/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  saveInfoStore(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/stores/info_panel/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateStore(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/stores/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateEmployees(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/employees/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateDevices(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/devices/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateTags(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/tags/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateProviders(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/providers/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateVisitors(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/visitors/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateDrivers(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/drivers/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateCars(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/cars/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateFacility(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/facility/update/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteUsers(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().set('id', form.get('id')?.value);

    return this.http.post<Responses>(
      this.domain + 'admin/users/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteStore(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().set('id', form.get('id')?.value);

    return this.http.post<Responses>(
      this.domain + 'admin/index/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteEmployees(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().set('id', form.get('id')?.value);

    return this.http.post<Responses>(
      this.domain + 'admin/employees/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteProviders(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().set('id', form.get('id')?.value);

    return this.http.post<Responses>(
      this.domain + 'admin/providers/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteVisitors(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().set('id', form.get('id')?.value);

    return this.http.post<Responses>(
      this.domain + 'admin/visitors/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteDrivers(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().set('id', form.get('id')?.value);

    return this.http.post<Responses>(
      this.domain + 'admin/drivers/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteCars(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().set('id', form.get('id')?.value);

    return this.http.post<Responses>(
      this.domain + 'admin/cars/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteDevices(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().set('id', form.get('id')?.value);

    return this.http.post<Responses>(
      this.domain + 'admin/devices/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteTags(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().set('id', form.get('id')?.value);

    return this.http.post<Responses>(
      this.domain + 'admin/tags/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteRoundsConfiguration(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);

    return this.http.post<Responses>(
      this.domain + 'admin/rounds/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteGuards(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().set('id', form.get('id')?.value);

    return this.http.post<Responses>(
      this.domain + 'admin/guards/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  deleteFacility(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().set('id', form.get('id')?.value);

    return this.http.post<Responses>(
      this.domain + 'admin/facility/delete/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  createReportExcel(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/facility/report/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    ).pipe(map((response: any) => this.fixReportPath(response)));
  }
  createReportPdf(form: UntypedFormGroup): Observable<Responses> {
    const body = new HttpParams().appendAll(form.value);
    return this.http.post<Responses>(
      this.domain + 'admin/facility/pdf/',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    ).pipe(map((response: any) => this.fixReportPath(response)));
  }

  // ---- Task checklists (Tareas) ----
  getAllTaskChecklists(facility_id?: number): Observable<Responses> {
    let params = new HttpParams();
    if (facility_id) {
      params = params.set('facility_id', facility_id);
    }
    return this.http.get<Responses>(
      this.domain + 'admin/task_checklists',
      { params }
    );
  }
  getTaskChecklistsByFacility(facility_id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/task_checklists/by_facility/' + facility_id
    );
  }
  getTaskChecklist(id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/task_checklists/' + id
    );
  }
  createTaskChecklist(data: { facility_id: number; label: string; observation?: string; email_notification?: string; items: any[] }): Observable<Responses> {
    const body = new HttpParams()
      .set('facility_id', data.facility_id)
      .set('label', data.label)
      .set('observation', data.observation ?? '')
      .set('email_notification', data.email_notification ?? '')
      .set('items', JSON.stringify(data.items ?? []));
    return this.http.post<Responses>(
      this.domain + 'admin/task_checklists/create',
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateTaskChecklist(id: number, data: { label?: string; observation?: string; email_notification?: string; items?: any[] }): Observable<Responses> {
    let body = new HttpParams();
    if (data.label !== undefined) {
      body = body.set('label', data.label);
    }
    if (data.observation !== undefined) {
      body = body.set('observation', data.observation ?? '');
    }
    if (data.email_notification !== undefined) {
      body = body.set('email_notification', data.email_notification ?? '');
    }
    if (data.items !== undefined) {
      body = body.set('items', JSON.stringify(data.items));
    }
    return this.http.post<Responses>(
      this.domain + 'admin/task_checklists/update/' + id,
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }
  updateTaskChecklistStatus(id: number, active: boolean): Observable<Responses> {
    const body = new HttpParams().set('active', active ? '1' : '0');
    return this.http.post<Responses>(
      this.domain + 'admin/task_checklists/update_status/' + id,
      body,
      {
        headers: new HttpHeaders().set(
          'Content-Type',
          'application/x-www-form-urlencoded'
        ),
      }
    );
  }

  // ---- Task checklist executions (Tareas · resultados) ----
  getAllTaskExecutions(filters?: {
    facility_id?: number;
    task_checklists_id?: number;
    guards_id?: number;
    status?: string;
  }): Observable<Responses> {
    let params = new HttpParams();
    if (filters) {
      Object.keys(filters).forEach((key) => {
        const value = (filters as any)[key];
        if (value !== undefined && value !== null && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get<Responses>(
      this.domain + 'admin/task_checklist_executions',
      { params }
    );
  }
  getTaskExecutionsByFacility(facility_id: number): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/task_checklist_executions/by_facility/' + facility_id
    );
  }
  getTaskExecution(id: number | string): Observable<Responses> {
    return this.http.get<Responses>(
      this.domain + 'admin/task_checklist_executions/' + id
    );
  }
}